var _ellipse, _ellipse2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCinema4D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 24.5,
    fill: "#616161",
    rx: 18.5,
    ry: 19.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 20.419,
    fill: "#212121",
    rx: 15,
    ry: 14.516
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3949ab",
    d: "M27,7c0,0,5,2,2.899,3.782c-1.063,0.901-2.414,1.378-3.674,1.968 c-1.463,0.685-2.97,1.28-4.292,2.238c-0.999,0.724-1.943,1.502-2.621,2.548c-0.812,1.252-1.29,2.622-1.372,4.118 c-0.074,1.347,0.176,2.641,0.736,3.86c0.799,1.74,2.096,3.013,3.798,3.889c1.212,0.624,2.497,0.913,3.853,0.881 c1.588-0.037,3.051-0.487,4.364-1.393c0.745-0.514,1.339-1.166,1.899-1.88c0.648-0.826,1.171-1.714,1.62-2.65 c0.559-1.164,0.98-2.384,1.443-3.588c0.355-0.922,0.717-1.849,1.268-2.672C39,15,41,18,41,18s-1-4-4-7S27,7,27,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M38,20c-0.44,5.613-1.547,9.809-3.06,12.926c-2.3,5.692-8.099,9.594-14.737,9.018 c-6.975-0.606-12.623-6.317-13.159-13.298c-0.425-5.533,2.261-10.466,6.487-13.253C16.989,12.844,21.838,11.832,26,11 c3.372-0.674,5.038-1.69,5.766-2.739c0.716-1.032,0.161-2.471-1.012-2.919c-2.693-1.027-5.65-1.515-8.755-1.287 C11.255,4.844,2.806,14.112,3.004,24.883C3.219,36.666,13.377,46.02,25.441,44.911c9.176-0.844,16.776-7.919,18.277-17.01 c0.659-3.989,0.127-7.783-1.253-11.142c-0.647-1.573-2.863-1.716-3.63-0.198C38.247,17.726,38.056,19.286,38,20z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema4D);
export default __webpack_public_path__ + "static/media/cinema4d.c522e92f7fc227359a8585b1e0edc641.svg";
export { ForwardRef as ReactComponent };